export { default as Vis } from './taxogenomic/Vis.jsx';